module.exports = __webpack_public_path__ + "img/step2.2.fd34262b.svg";